import { render, staticRenderFns } from "./Snack.vue?vue&type=template&id=417138f8&scoped=true&"
import script from "./Snack.vue?vue&type=script&lang=js&"
export * from "./Snack.vue?vue&type=script&lang=js&"
import style0 from "./Snack.vue?vue&type=style&index=0&id=417138f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "417138f8",
  null
  
)

export default component.exports